<script>
import {bemMixin, filterEmpty, getOptionProps, hasProp, getVnodeName} from "../utils";
export default {
  name: "g-tabs",
  mixins: [bemMixin],
  model: {
    prop: "activeKey",
    event: "change"
  },
  props: {
    defaultActiveKey: {
      type: [String, Number],
      default: void 0
    },
    size: {
      type: String,
      default: "normal"
    },
    activeKey: {
      type: [String, Number],
      default: void 0
    }
  },
  data() {
    return {
      value: this.defaultActiveKey,
      inkStyle: null
    };
  },
  computed: {
    innerActiveKey() {
      if (hasProp(this, "activeKey"))
        return this.activeKey;
      if (this.value)
        return this.value;
      return "";
    }
  },
  mounted() {
    if (!this.innerActiveKey) {
      this.value = this.$children[0].value;
    }
    this.$nextTick(this.changeInkStyle);
  },
  updated() {
    this.changeInkStyle();
  },
  methods: {
    changeInkStyle() {
      if (!this.$refs.bar || !this.$refs.ink)
        return;
      const panel = this.$refs.bar.querySelector(".g-tabs__tab--active");
      if (!panel)
        return;
      this.$refs.ink.style.transform = `translate3d(${panel.offsetLeft}px, 0px, 0px)`;
      this.$refs.ink.style.width = `${panel.offsetWidth}px`;
    },
    changeValue(value) {
      this.value = value;
      this.$emit("change", value);
      this.$emit("update:activeKey", value);
      this.$nextTick(this.changeInkStyle);
    },
    getActiveValue(prop) {
      if ("activeKey" in prop && prop.activeKey !== null) {
        return prop.activeKey;
      }
      return prop.tab;
    }
  },
  render() {
    const children = filterEmpty(this.$slots.default);
    const tabs = children.map((c) => {
      const name = getVnodeName(c);
      if (name === "g-tab-line") {
        return /* @__PURE__ */ this._c("div", {
          class: this.bem("line")
        });
      } else if (name === "g-tab-panel") {
        const props = getOptionProps(c);
        return /* @__PURE__ */ this._c("div", {
          role: "tab",
          key: this.getActiveValue(c),
          class: this.bem("tab", {active: this.getActiveValue(props) === this.innerActiveKey, disabled: c.disabled}),
          onClick: () => this.changeValue(this.getActiveValue(props))
        }, typeof props.tab === "function" ? props.tab() : props.tab);
      }
      return null;
    });
    return /* @__PURE__ */ this._c("div", {
      class: this.bem([this.size])
    }, /* @__PURE__ */ this._c("div", {
      class: this.bem("bar"),
      ref: "bar"
    }, /* @__PURE__ */ this._c("div", {
      class: this.bem("ink-bar"),
      ref: "ink"
    }), /* @__PURE__ */ this._c("div", {
      class: this.bem("tab-wrapper")
    }, tabs), this.$slots.extra ? /* @__PURE__ */ this._c("div", {
      class: this.bem("extra-content")
    }, this.$slots.extra) : null), /* @__PURE__ */ this._c("div", {
      class: this.bem("content")
    }, this.$slots.default));
  }
};

</script>
<style>
.g-tabs {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  -webkit-font-feature-settings: 'tnum';
  font-feature-settings: 'tnum';
  position: relative;
  overflow: hidden;
  zoom: 1;
}
.g-tabs * {
  box-sizing: border-box;
}
.g-tabs__bar {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid #dadde1;
  min-height: 46px;
}
.g-tabs__tab-wrapper {
  display: flex;
}
.g-tabs__line {
  width: 1px;
  background: #EBEDF0;
  margin: 12px 0;
  margin-right: 16px;
}
.g-tabs__tab {
  display: inline-block;
  color: #444950;
  font-size: 14px;
  cursor: pointer;
  margin-right: 24px;
  padding: 12px 0;
}
.g-tabs__tab:last-child {
  margin-right: 0;
}
.g-tabs__tab--active {
  color: #000000;
  font-weight: bold;
}
.g-tabs__tab--disabled {
  color: #bec3c9;
  cursor: default;
}
.g-tabs__tab + .g-tabs__line {
  margin-right: 16px;
}
.g-tabs--large .g-tabs__tab {
  margin-right: 48px;
  font-size: 16px;
  line-height: 24px;
  padding: 12px 0;
}
.g-tabs--large .g-tabs__tab + .g-tabs__line {
  margin-left: -12px;
}
.g-tabs--large .g-tabs__line {
  margin-right: 32px;
}
.g-tabs__ink-bar {
  position: absolute;
  height: 4px;
  border-radius: 1px;
  background-color: #2254f4;
  width: 0px;
  left: 0;
  bottom: -1px;
  z-index: 1;
  transform-origin: 0 0;
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.g-tabs__content {
  margin-top: 16px;
}

</style>
